// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2hb94","loaderOuter":"PageOverlayLoader_loaderOuter__465Zd"};